import type { IdeoToastVariant } from './types';

export const IDEO_TOAST_DEFAULT_DURATION = 4000;

export function resolveIdeoToastDuration(variant: IdeoToastVariant, duration?: number)
{
    if (variant === 'loading' || duration === 0)
    {
        return Infinity;
    }

    return duration ?? IDEO_TOAST_DEFAULT_DURATION;
}
